export default __webpack_public_path__ + "static/media/illustration-how_convertibleNote.c92f95d3.png";